import React from 'react';
import ReactDOM from 'react-dom';

import { Scada } from './Scada';

ReactDOM.render(
  
   <Scada/>,
  document.getElementById('root')
);